import Reveal from "@/components/base/Reveal";

export default function Closing() {
  const goTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal>
          <div className="bg-secondary-800 rounded-lg overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-12">
              <div className="lg:col-span-8 p-7 md:p-12">
                <span className="inline-flex items-center gap-2 text-xs font-medium tracking-widest text-accent-400 uppercase">
                  <span className="w-6 h-px bg-accent-400"></span>
                  小结
                </span>
                <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-background-50 leading-snug">
                  把观看需求拆开，再一处一处对上
                </h2>
                <p className="mt-5 text-sm md:text-base text-secondary-200 leading-relaxed max-w-2xl">
                  这份页面没有把所有信息堆在一句口号里，而是按方向拆开：想直接开看，就关注在线观看；
                  想先零成本试试，就看免费观看标注；在意画面质量，去看高清播放的档位说明；用小屏看剧，翻到手机在线那一节。
                  最后再用抢先看片段和全集在线的进度，决定先追哪一部。
                </p>
                <div className="mt-8 flex flex-col sm:flex-row gap-3">
                  <button
                    onClick={() => goTo("library")}
                    className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-background-50 font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-play-list-line text-lg" aria-hidden="true"></i>
                    回到影片片单
                  </button>
                  <button
                    onClick={() => goTo("updates")}
                    className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-background-50/10 border border-background-50/25 text-background-50 font-medium hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-history-line text-lg" aria-hidden="true"></i>
                    查看更新动态
                  </button>
                </div>
              </div>

              <div className="lg:col-span-4 bg-secondary-900 p-7 md:p-12 flex flex-col justify-center">
                <p className="text-xs tracking-widest text-accent-400 uppercase">快速索引</p>
                <ul className="mt-5 space-y-3">
                  {[
                    { id: "directions", text: "核心方向：四种观看需求的区别" },
                    { id: "library", text: "影片片单：按题材与方式筛选" },
                    { id: "series", text: "全集在线：连载进度对照" },
                    { id: "faq", text: "常见问题：容易卡住的环节" },
                  ].map((item) => (
                    <li key={item.id}>
                      <button
                        onClick={() => goTo(item.id)}
                        className="group flex items-center gap-2 text-sm text-secondary-200 hover:text-accent-400 transition-colors cursor-pointer text-left"
                      >
                        <i className="ri-arrow-right-s-line text-accent-500 group-hover:translate-x-0.5 transition-transform" aria-hidden="true"></i>
                        {item.text}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}